import * as Y from 'yjs';

import { UpdateMessageOrigin } from '@canvas/protocol-types';
import {
  CanvasTransactionOrigin,
  type TransactionOrigin,
  YJS_DEFAULT,
  type Transaction,
  type YjsOrigin as YjsOriginInterface,
} from '@canvas/transaction-types';

const CanvasTransactionOriginValues = new Set(Object.values(CanvasTransactionOrigin));

export const isTransactionOrigin = (val: any): val is TransactionOrigin => {
  return val === YJS_DEFAULT || val === undefined || isCanvasTransactionOrigin(val);
};

const isUndoManager = (origin: TransactionOrigin) => {
  return (
    origin instanceof Y.UndoManager ||
    CanvasTransactionOrigin.RemoteUndoManager === origin
  );
};

const isCanvasTransactionOrigin = (origin: string): origin is CanvasTransactionOrigin => {
  return CanvasTransactionOriginValues.has(origin as CanvasTransactionOrigin);
};
export const originIsUndoManager = (origin: TransactionOrigin) => {
  const isYjsOriginUndoManager =
    origin instanceof YjsOrigin &&
    (isUndoManager(origin.remoteOrigin) || isUndoManager(origin.localOrigin));
  return isUndoManager(origin) || isYjsOriginUndoManager;
};

export function getUpdateMessageOrigin(origin: TransactionOrigin): UpdateMessageOrigin {
  let flag = UpdateMessageOrigin.None;
  if (originIsUndoManager(origin)) {
    flag |= UpdateMessageOrigin.UndoRedo;
  }
  return flag;
}

export const originatesFromUndoManager = (transaction: Transaction) =>
  originIsUndoManager(transaction.origin);

export class YjsOrigin implements YjsOriginInterface {
  constructor(
    public readonly remoteOrigin: TransactionOrigin,
    public readonly localOrigin: TransactionOrigin
  ) {}
}

export {
  CanvasTransactionOrigin,
  YJS_DEFAULT,
  type CanvasTransaction,
} from '@canvas/transaction-types';

export { TransactionOrigin, Transaction };
